import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../AuthContext";
import { API } from "../api";

// FitLah — a wellness mini-app (postpartum recovery, fitness goals, mood,
// food log) for office staff personal use. The full UI lives as a
// self-contained HTML file at /fitlah-app.html so the original artifact's
// design, workout library, and meal-idea data are preserved 1-to-1.
//
// This React page is the thin wrapper that loads it full-screen. We pass
// the JWT + API base URL + current user id into the iframe via URL hash
// (NOT query string — the hash is never sent to the server and never
// logged) so the static HTML can sync state to the backend per logged-in
// user AND so a shared device clears the previous user's local cache.
export default function FitLah() {
  const { user } = useAuth();
  const src = useMemo(() => {
    const token = localStorage.getItem("mercy_token") || "";
    const uid = user?.id || "";
    const hash =
      `#api=${encodeURIComponent(API)}` +
      `&token=${encodeURIComponent(token)}` +
      `&uid=${encodeURIComponent(uid)}`;
    return `/fitlah-app.html${hash}`;
  }, [user?.id]);

  return (
    <div className="fixed inset-0 bg-[#F7FAFD] z-30">
      <Link
        to="/hub"
        title="Back to Mercy hub"
        className="fixed top-3 right-3 z-40 inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-white border border-slate-200 text-slate-600 hover:text-slate-900 hover:border-slate-300 text-xs shadow-sm"
        data-testid="fitlah-back-hub"
      >
        <ArrowLeft className="w-3.5 h-3.5" /> Mercy hub
      </Link>
      <iframe
        src={src}
        title="FitLah wellness app"
        className="w-full h-full border-0"
        allow="camera; clipboard-write; geolocation"
        data-testid="fitlah-frame"
      />
    </div>
  );
}
